
import * as echarts from 'echarts';

/**
 * @desc 时间戳格式化为时间
 * @param {*val}
 */
export const demoFuntion = function (params) {
  
}

/**
 * @desc 折线图
 * @param {*XtimeArray} array
 * @param {*YdataArray1} 家长压力
 * @param {*YdataArray2} 家长行为
 *  @param {*unit} 单位
 */
export const drawLine = function (id, XtimeArray, YdataArray1, YdataArray2, unit) {
  let myChart = echarts.init(document.getElementById(id));
  myChart.clear();
  myChart.resize()
  let option = {
    grid: {
      left: '0%',
      right: '0%',
      top: '5%',
      bottom: '0%',
      containLabel: true
    },
    tooltip: {
      trigger: 'axis',
      confine: true,
      extraCssText: 'white-space: normal; word-break: break-all;',
      formatter: function (params) {
        let tempLength = params.length
        if (tempLength == 1) {
          return `
          ${params[0].marker}${params[0].name} <span style='color: #FF8340'> ${params[0].data ? params[0].data : 0} ${unit}</span> </br>
        `
        } else if (tempLength == 2) {
          return `
          ${params[0].marker}${params[0].name} <span style='color: #FF8340'> ${params[0].data ? params[0].data : 0} ${unit}</span> </br>
          ${params[1].marker}${params[1].name}  <span style='color: #FFD600'>${params[1].data ? params[1].data : 0} ${unit}</span>
        `
        }
      }
    },
    xAxis: {
      type: 'category',
      boundaryGap: true,
      data: XtimeArray,
      axisLine: {
        lineStyle: {
          color: '#cccccc'
        }
      },
      axisLabel: {
        show: true,
        textStyle: {
          color: '#999999'
        },
        // rotate: 30
      }
    },
    yAxis: {
      type: 'value',
      axisLine: {
        lineStyle: {
          color: '#cccccc'
        }
      },
      axisLabel: {
        show: true,
        textStyle: {
          color: '#999999'
        }
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: ['#ECECEC'],
          width: 1,
          type: 'solid'
        }
      },
    },
    series: [
      {
        type: 'line',
        smooth: true,
        symbol: 'circle',//实心的拐点
        symbolSize: 5,
        itemStyle: {
          borderWidth: 3,
        },
        // labelLine: {
        //   show:true,
        //   lineStyle: {
        //     color: 'red'
        //   }
        // },
        lineStyle: {
          color: '#ff8340',
          shadowColor: '#ff8340',
          shadowBlur: 6,
          shadowOffsetY: 2
        },
        // 折线拐点的设置
        itemStyle: {
          color: '#ff8340',
          borderType: 'solid',
        },
        data: YdataArray1
      },
      {
        type: 'line',
        smooth: true,
        symbol: 'circle',//实心的拐点
        symbolSize: 5,
        itemStyle: {
          borderWidth: 3,
        },
        lineStyle: {
          type: 'solid',
          color: '#ffd600',
          shadowColor: '#ffd600',
          shadowBlur: 6,
          shadowOffsetY: 2
        },
        // 折线拐点的设置
        itemStyle: {
          color: '#ffd600',
          borderType: 'solid'
        },
        data: YdataArray2
      }
    ],
    dataZoom: [{
      type: 'inside',
      startValue: 0,
      endValue: 6,
      height: '0',
      bottom: '0',
      zoomLock: true
    }, {
      startValue: 0,
      endValue: 6,
      height: '0',
      bottom: '0',
      zoomLock: true
    }]
  }
  myChart.setOption(option, true);
}

/**
 * @desc 饼图
 * @param {*XtimeArray} 
 * @param {*YdataArray1} 
 * @param {*YdataArray2} 
 *  @param {*unit} 
 */
export const drawPie = function (id, dataArray) {
  let myChart = echarts.init(document.getElementById(id));
  myChart.clear();
  myChart.resize()
  let option = {
    tooltip: { trigger: "item" },
    // 图例组件的相关配置像设置
    // legend: {
    //   top: "90%",
    //   itemWidth: 10,
    //   itemHeight: 10,
    //   data: [],
    //   textStyle: {
    //     color: "rgba(255,255,255,.5)",
    //     fontSize: "12"
    //   }
    // },
    series: [
      {
        name: "Hi",
        type: "pie",
        center: ["50%", "50%"],
        radius: ["30%", "60%"],
        avoidLabelOverlap: false,
        color: ['#ff8340', '#ffd600'],
        label: {
          show: false
        },
        // 修饰饼形图文字相关的样式 label对象
        // label: {
        //   show: false,
        //   fontSize: 12,
        //   fontWeight: 500,
        //   color: '#333333',
        //   // formatter: "{b}\n{d}%",
        // //   formatter: [
        // //     '{b}',
        // //     '{d}%'
        // // ].join('\n'),
        // formatter: function(params) {
        //   let dealDate = params.name
        //   let percentData = Math.round(params.value)+'%'
        //   // 保留空格换行
        //   return `${dealDate}
        //   ${percentData}`
        // }
        // },
        // 修饰引导线样式
        // labelLine: {
        //   show: false,
        //   // 连接到图形的线长度
        //   length: 25,
        //   // 连接到文字的线长度
        //   length2: 18,
        // },
        // data: [
        //   { value: 1, name: "能量" },
        //   { value: 4, name: "碳水化合物" },
        //   { value: 2, name: "蛋白质" },
        //   { value: 2, name: "脂肪" },
        // ]
        data: dataArray
      }
    ]
  };
  myChart.setOption(option, true);
}

/**
 * @desc 柱状图
 * @param {*XtimeArray} 
 * @param {*YdataArray1} 
 * @param {*YdataArray2} 
 *  @param {*unit} 
 */
export const drawBar = function (id, Xdata, Ydata) {
  let myChart = echarts.init(document.getElementById(id));
  myChart.clear();
  myChart.resize()
  let option = {
    backgroundColor: '#fff',
    // tooltip: {
    //     trigger: 'axis',
    //     confine: true,
    //     extraCssText: 'white-space: normal; word-break: break-all;',
    //     formatter: function(params) {
    //       // return `${params[0].name}<br/>${params[0].marker}${params[0].seriesName}&nbsp${params[0].value}%`
    //     }
    // },
    grid: {
      top: "15%",
      left: '0%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: true,
      data: Xdata,
      axisLine: {
        lineStyle: {
          color: '#ccc'
        }
      },
      axisLabel: {
        show: true,
        interval: 0,//横轴左边下方全部展示，默认1，隔行显示
        textStyle: {
          color: '#999'
        },
        // backgroundColor: "red",
        rotate: 15,
        align: "center",
        margin: 20,
        // align: 'center',
        // overflow: 'break',
        // width: 300 / Xdata.length,
        // height: 60,
        // lineHeight: 16
      }
    },
    yAxis: {
      type: 'value',
      axisLine: {
        lineStyle: {
          color: '#ccc'
        }
      },
      axisLabel: {
        show: true,
        textStyle: {
          color: '#999'
        }
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: '#ECECEC'
        }
      },
    },
    series: [
      {
        name: '灰太狼',
        type: 'bar',
        itemStyle: {

          normal: {
            color: new echarts.graphic.LinearGradient(
              0, 0, 0, 1,
              [
                { offset: 0, color: '#f07eb9' },
                { offset: 0.5, color: '#f07eb9' },
                { offset: 1, color: '#f07eb9' }
              ]
            ),
            label: {
              show: true,
              position: 'top',
              textStyle: {
                color: '#ccc',
                fontSize: 12,
              }
            }
          }

          // label: {
          //   show: true,
          //   position: 'top',
          // }
          //柱形图圆角，初始化效果
          // barBorderRadius:[15, 15, 0, 0]
        },
        stack: 'total',
        barWidth: 20,
        emphasis: {
          focus: 'series'
        },
        data: Ydata
      },
    ],
    dataZoom: [{
      type: 'inside',
      startValue: 0,
      endValue: 6,
      height: '0',
      bottom: '0',
      zoomLock: true
    }, {
      startValue: 0,
      endValue: 6,
      height: '0',
      bottom: '0',
      zoomLock: true
    }]
  };
  myChart.setOption(option, true);
}

/**
 * @desc 雷达图
 * @param {*XtimeArray} 
 * @param {*YdataArray1} 
 * @param {*YdataArray2} 
 *  @param {*unit} 
 */

export const drawRadar = function (id, indicatorInfo, dataArray) {
  let myChart = echarts.init(document.getElementById(id));
  myChart.clear()
  myChart.resize()
  let option = {
    tooltip: {
      textStyle: {
        color: '#333',
        fontSize: 12,
      },
      trigger: 'item',
      //雷达图的tooltip不会超出div
      confine: true,
      enterable: true, //鼠标是否可以移动到tooltip区域内
      formatter: function (params) {

      }
    },
    radar: {
      nameGap: 1,// 指示器名称和指示器轴的距离。
      splitNumber: 5, // 雷达图圈数设置
      center: ['50%', '50%'],
      radius: '70%',
      // shape: 'circle',
      indicator: indicatorInfo,
      //雷达图背景的颜色
      splitArea: {
        show: true,
        // 分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。
        areaStyle: {
          color: ['rgba(255, 255, 255,0.3)', '#FCF7F0', '#FCF7F0', '#FCF7F0'],
        },
      },

      // 坐标轴在 grid 区域中的分隔线。一圈一圈的那个线
      splitLine: {
        lineStyle: {
          color: '#E9E9E9'
        }
      },
      name: {
        formatter: function (value, indicator) {
          // indicator.name.replace(/(.{6})/g, '\n')
          indicator.name = indicator.name.replace(/(.{7})/g, '$1\n')
          return `${indicator.name} ${indicator.scoreValue}`
          // return  `${indicator.name} ${indicator.percent}%`
        },
        textStyle: {
          color: '#333333',
          borderRadius: 3,
          padding: [3, 5],
        },
      },
      // axisName: {
      //   overflow: 'break',
      // }
    },
    series: [
      {
        name: '蕉太狼',
        type: 'radar',
        symbol: 'circle', // 拐点的样式，还可以取值'rect','angle'等
        symbolSize: 'none', // 拐点的大小
        silent: true,
        // 点连线的颜色
        itemStyle: {
          color: '#FF9300',
          borderWidth: 1,
        },
        data: [
          {
            value: dataArray,
            itemStyle: {
              emphasis: {
                lineStyle: {
                  width: 4
                }
              }
            },
            areaStyle: {
              color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                { color: 'rgba(246, 230, 198, 0.6)', offset: 0 },
                { color: 'rgba(246, 230, 198, 0.5)', offset: 1 }
              ])
            },
          },
        ]
      },
    ]
  };
  myChart.setOption(option, true);
}
//  学习占比的雷达图
export const drawRadar2 = async function (id, indicatorInfo, dataArray) {
  let myChart = await echarts.init(document.getElementById(id));
  myChart.clear()
  myChart.resize()
  let option = {
    tooltip: {
      textStyle: {
        color: '#333',
        fontSize: 12,
      },
      trigger: 'item',
      //雷达图的tooltip不会超出div
      confine: true,
      enterable: true, //鼠标是否可以移动到tooltip区域内
      formatter: function (params) {

      }
    },
    radar: {
      nameGap: 1,// 指示器名称和指示器轴的距离。
      splitNumber: 5, // 雷达图圈数设置
      center: ['50%', '50%'],
      radius: '70%',
      // shape: 'circle',
      indicator: indicatorInfo,
      //雷达图背景的颜色
      splitArea: {
        show: true,
        // 分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。
        areaStyle: {
          color: ['rgba(255, 255, 255,0.3)', '#FCF7F0', '#FCF7F0', '#FCF7F0'],
        },
      },
      // 坐标轴在 grid 区域中的分隔线。一圈一圈的那个线
      splitLine: {
        lineStyle: {
          color: '#E9E9E9'
        }
      },
      name: {
        formatter: function (value, indicator) {
          return `${indicator.name} ${indicator.scoreValue}`
          // return  `${indicator.name} ${indicator.percent}%`
        },
        textStyle: {
          color: '#333333',
          borderRadius: 3,
          padding: [3, 5],
        },
      },
    },
    series: [
      {
        name: '蕉太狼',
        type: 'radar',
        symbol: 'circle', // 拐点的样式，还可以取值'rect','angle'等
        symbolSize: 'none', // 拐点的大小
        silent: true,
        // 点连线的颜色
        itemStyle: {
          color: '#FF9300',
          borderWidth: 1,
        },
        data: [
          {
            value: dataArray,
            itemStyle: {
              emphasis: {
                lineStyle: {
                  width: 4
                }
              }
            },
            areaStyle: {
              color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                { color: 'rgba(246, 230, 198, 0.6)', offset: 0 },
                { color: 'rgba(246, 230, 198, 0.5)', offset: 1 }
              ])
            },
          },
        ]
      },
    ]
  };
  myChart.setOption(option, true);
}

// 清楚echarts
export const clear = function (id) {
  let myChart = echarts.init(document.getElementById(id));
  myChart.clear();
  myChart.resize()
}


